import './Day.css';

const Day = ({ dayData, dataOriginName, index }) => {

    let rainColor = '';
    if ((dayData.rain !== 0 && dayData.rain !== '0.0')){
        rainColor = 'day__rain-amount--blue';
    }

    const dayDate = () => {
        if (index === 0) {
            return <div className="day__date day__date--first">Hoy</div>
        } else {
            return <div className="day__date">{dayData.date}</div>
        }
    }

    return (
        <div className="day__row">
            {dayDate()}
            <div className="day__data">
                <div className="day__grades">
                    <div className="day__grades-icon">
                        <img src="/icons/icon-max.svg" alt="Max temp" />
                    </div>
                    <div className="day__grades-number">
                        {dayData.tempMax}°
                    </div>
                </div>
                <div className="day__grades">
                    <div className="day__grades-icon">
                        <img src="/icons/icon-min.svg" alt="Min temp" />
                    </div>
                    <div className="day__grades-number">
                        {dayData.tempMin}°
                    </div>
                </div>
                <div className="day__icon">
                    <img className={`day__icon--${dataOriginName}`} src={dayData.iconSrc} alt="" />
                </div>
                <div className="day__wind">
                    {dayData.wind}<span className="day__km-h">km/h</span>
                </div>
                <div className="day__rain">
                    <div className="day__rain-prob">{dayData.rainProb}% Prob</div>
                    <div className={`day__rain-amount ${rainColor}`}>{dayData.rain} mm</div>
                </div>
            </div>
        </div>
    );
}
  
export default Day;
